// pages/LoginPage.jsx
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome,faUser, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const res = await axios.post('/api/login', { email, password });
      const { token, user } = res.data;

      // Store token in localStorage or cookie
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      // Navigate to dashboard or home
      navigate('/auth/profile');
    } catch (err) {
      console.log(err);
      setError(err.response?.data?.error || 'Login failed');  
      
    }
  };

  return (
    <div>
     <Link to={`/`} className="header-button">
                                <FontAwesomeIcon icon={faHome} /> &nbsp;  Home
                              </Link>
    <div style={{ padding: 20 }}>
      
      <h2>Login</h2>
       <section className="contact"> 
      <form onSubmit={handleLogin} className="contact-from">

        <div className="input-box">
          <label>Email</label>
          <input
            type="email"
            className="field"
            placeholder="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <br />
         <div className="input-box" style={{ position: 'relative' }}>
             <label>Password</label>
             <input
               name="password"
               type={showPassword ? 'text' : 'password'}
               className="field"
               placeholder="Password"
               value={password}
              onChange={(e) => setPassword(e.target.value)}
               required
             />
              <span
               onClick={() => setShowPassword((prev) => !prev)}
               style={{
                 position: 'absolute',
                 right: '20px',
                 top: '48px',
                 cursor: 'pointer',
                 color: '#888',
               }}
             >
               {showPassword ?  <FontAwesomeIcon icon={faEyeSlash} /> :  <FontAwesomeIcon icon={faEye} />}
             </span>
           </div>
             
        <br />
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <button type="submit"> <FontAwesomeIcon icon={faUser} /> Login </button>
        <br />   
      </form>
      </section>
      <br />
      <p>Don't have an account? </p>
        <br />
        <Link to={`/auth/registerform`} className="header-button">
                    <FontAwesomeIcon icon={faUser} /> &nbsp; Register
                  </Link>
    </div>
    </div>
  );
};

export default Login;
